import { render, staticRenderFns } from "./AddEstadocivilPage.vue?vue&type=template&id=3401fa76&"
import script from "./AddEstadocivilPage.vue?vue&type=script&lang=js&"
export * from "./AddEstadocivilPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports